/* Connect editorial size controls to Dawn's native variant selection. */
if (!customElements.get('omaveri-ab-v2-details')) {
  customElements.define('omaveri-ab-v2-details', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('click', (event) => this.selectSize(event), { signal: this.controller.signal });
      this.addEventListener('click', (event) => this.returnToOptions(event), { signal: this.controller.signal });
      document.addEventListener('product-info:loaded', () => this.connectProduct(), { signal: this.controller.signal });
      document.addEventListener('shopify:section:load', () => this.connectProduct(), { signal: this.controller.signal });
      this.connectProduct();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.connectProduct(), { once: true, signal: this.controller.signal });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribeVariant?.();
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = null;
      this.unsubscribeVariant = null;
      this.productInfo = null;
    }

    connectProduct() {
      const productInfo = Array.from(document.querySelectorAll('product-info[data-update-url="true"]')).find((element) =>
        element.id.endsWith('__ab_main') && element.dataset.productId === this.dataset.productId
      );
      if (!productInfo) return;
      if (this.productInfo !== productInfo) {
        this.visibilityObserver?.disconnect();
        this.visibilityObserver = null;
      }
      this.productInfo = productInfo;
      this.syncJumpLinks();

      const sticky = this.querySelector('[data-ab-sticky]');
      if (sticky && !this.visibilityObserver && 'IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
        });
        this.visibilityObserver.observe(productInfo);
      }

      if (!this.unsubscribeVariant && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event?.data;
          if (!data?.variant || data.sectionId !== this.productInfo?.dataset.section) return;
          const nativeId = this.productInfo.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
          if (nativeId && String(data.variant.id) !== nativeId) return;
          this.updateSelected(data.variant.id);
        });
      }

      this.querySelectorAll('[data-ab-variant]').forEach((button) => {
        button.disabled = !this.nativeOption(button.dataset.abOption);
      });
      const selected = productInfo.querySelector('variant-selects script[data-selected-variant]');
      try {
        const variant = JSON.parse(selected?.textContent || 'null');
        if (variant?.id) this.updateSelected(variant.id);
      } catch {
        // The native form remains authoritative if its optional JSON is unavailable.
      }
    }

    nativeOption(value) {
      return Array.from(this.productInfo?.querySelectorAll('variant-selects input[type="radio"]') || [])
        .find((input) => input.value === value);
    }

    syncJumpLinks() {
      const navigation = this.productInfo?.querySelector('.omaveri-ab-jump');
      if (!navigation) return;
      const links = Array.from(navigation.querySelectorAll('a[href^="#ab-"]'));
      links.forEach((link) => {
        link.hidden = !document.getElementById(link.getAttribute('href').slice(1));
      });
      navigation.hidden = links.length > 0 && links.every((link) => link.hidden);
    }

    selectSize(event) {
      const button = event.target.closest('[data-ab-variant]');
      if (!button || !this.contains(button) || button.disabled) return;
      const input = this.nativeOption(button.dataset.abOption);
      if (!input || input.disabled || input.checked) return;
      // A native click updates Dawn's option selection, price, availability,
      // gallery, cart variant and URL through the normal product-info flow.
      input.click();
    }

    returnToOptions(event) {
      const link = event.target.closest('[data-ab-return-options]');
      if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!this.productInfo?.isConnected) this.connectProduct();
      const picker = this.productInfo?.querySelector('variant-selects');
      const input = picker?.querySelector('input[type="radio"]:checked:not(:disabled)') ||
        picker?.querySelector('input[type="radio"]:not(:disabled)') || picker?.querySelector('select:not(:disabled)');
      if (!input) return;
      const target = input.closest('fieldset, .product-form__input') || picker;
      input.focus({ preventScroll: true });
      if (document.activeElement !== input) return;
      event.preventDefault();
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    updateSelected(variantId) {
      const selectedId = String(variantId);
      this.querySelectorAll('[data-ab-variant]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.abVariant === selectedId));
      });
      this.querySelectorAll('[data-ab-measurement]').forEach((row) => {
        row.classList.toggle('is-selected', row.dataset.abMeasurement === selectedId);
      });
      this.querySelectorAll('[data-ab-size-image]').forEach((image) => {
        image.hidden = image.dataset.abSizeImage !== selectedId;
      });
      this.querySelectorAll('[data-ab-pending]').forEach((notice) => {
        notice.hidden = notice.dataset.abPending !== selectedId;
      });
      this.querySelectorAll('[data-ab-sticky-variant]').forEach((summary) => {
        summary.hidden = summary.dataset.abStickyVariant !== selectedId;
      });
    }
  });
}
